/**
 * ShortcutLegend — the "?" panel listing the door's keyboard shortcuts
 * (proposal 9). Bottom-right, dark, never modal: the list stays usable
 * behind it. The shell owns whether it is open (useDoorShortcuts toggles it).
 */
import styles from './ShortcutLegend.module.css';

const SHORTCUTS: ReadonlyArray<{ keys: string; does: string }> = [
  { keys: 'j / k', does: 'next / previous item' },
  { keys: 'Enter', does: 'open the item' },
  { keys: 'o', does: 'open as a case' },
  { keys: 's', does: 'send to someone else' },
  { keys: 'd', does: 'done, issue handled' },
  { keys: 'n', does: 'not an issue' },
  { keys: 'a', does: 'ask a colleague' },
  { keys: '/', does: 'search' },
  { keys: 'g t · g c · g d · g p', does: 'Triage · Cases · Done · Pending' },
  { keys: 'Esc', does: 'close panel, back to the list' },
];

export function ShortcutLegend({ onClose }: { onClose: () => void }) {
  return (
    <aside className={styles.panel} aria-label="Keyboard shortcuts" data-testid="shortcut-legend">
      <div className={styles.head}>
        <h2 className={styles.title}>Keyboard shortcuts</h2>
        <span className={styles.hint}>? to toggle · Esc closes</span>
        <button type="button" className={styles.close} onClick={onClose} aria-label="Close keyboard shortcuts">
          ×
        </button>
      </div>
      <dl className={styles.list}>
        {SHORTCUTS.map((s) => (
          <div key={s.keys} className={styles.row}>
            <dt>
              <kbd className={styles.kbd}>{s.keys}</kbd>
            </dt>
            <dd className={styles.does}>{s.does}</dd>
          </div>
        ))}
      </dl>
      <p className={styles.foot}>
        Shortcuts wait while you type in a box. After Send or Save, focus returns to the list,
        never to a stage button.
      </p>
    </aside>
  );
}
